module.exports = __webpack_public_path__ + "media/site_templates/www.electriciannearme.agency/images/testimonials-6ab300360c7d111f04f9f9c4e583bda1.jpg";